import { FC, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import qs from 'query-string'

import { Icons } from '../../../components/Icon'
import { BlockProps } from '../props'
import { ActionButtonVariant } from '../../../components/ActionButton/styled'
import { AdsSortingFiltersVariant } from '../../../components/AdsSortingFilters/styled'
import { AdsSortingFiltersProps } from '../../../components/AdsSortingFilters'
import Router from '../../../routes/Router'
import routes from '../../../routes/definitions'
import { PublicationGuideSmallCardProps } from '../../../components/PublicationGuideSmallCard'
import { ActionButtonTransformer } from '../../Transformers/LinkTransformer'
import { useAdsSortingFiltersFormProps } from '../../Classified/Forms/useAdsSortingFiltersFormProps'
import { ListDisplayType } from '../../../types/classified'

import * as SC from './styled'
import { FormSearchAdsProps } from './props'

const FormSearchAds: FC<BlockProps<FormSearchAdsProps>> = ({
  data,
  specialities,
  categories,
}) => {
  const { t } = useTranslation()

  const formProps = useAdsSortingFiltersFormProps({
    specialities: specialities ?? [],
    categories: categories ?? [],
    isOpen: true,
    onSubmit: (values) => {
      Router.push(
        Router.getRouteUrl(routes.classifiedSearch) +
          '?' +
          qs.stringify(
            {
              ...(values.offerType && {
                offerType: values.offerType,
              }),
              ...(values.term && {
                terms: values.term,
              }),
              ...(values.localization && {
                lat: values.lat,
              }),
              ...(values.localization && {
                lng: values.lng,
              }),
              ...(values.radius && {
                radius: values.radius,
              }),
              ...(values.localization && {
                localization: values.localization,
              }),
              ...(values.specialities && {
                specialities: values.specialities,
              }),
              displayType: ListDisplayType.Card,
            },
            { arrayFormat: 'comma' }
          )
      )
    },
    submitButtonVariant: 'primary',
  })

  const SortingFiltersAdsProps: AdsSortingFiltersProps = useMemo(
    () => ({
      title: data?.title ?? '',
      searchForm: formProps,
      isOpen: true,
      variant: AdsSortingFiltersVariant.primary,
    }),
    [data, formProps]
  )

  const smallCardProps: PublicationGuideSmallCardProps = useMemo(
    () => ({
      title: t('smallCardGuideTitle'),
      text: t('smallCardGuideDescription'),
      button: {
        ...ActionButtonTransformer(data.link),
        variant: ActionButtonVariant.quaternary,
      },
    }),
    [t, data]
  )

  return (
    <SC.Section>
      <SC.SortingFiltersAds {...SortingFiltersAdsProps} />
      <SC.SmallCardPublicationGuide {...smallCardProps} />
      <SC.CrossesIcon icon={Icons.crossesSecondary} width={135} height={106} />
    </SC.Section>
  )
}
export default FormSearchAds
